import { PublicClientApplication, Configuration, AccountInfo } from '@azure/msal-browser';
import config from '../config';
import { LogLevel } from "@azure/msal-browser";

// MSAL Configuration
const msalConfig: Configuration = {
  auth: {
    authority: config.OAUTH_URL,
    clientId: config.CLIENT_ID,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
  system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }		
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    default:
                        return;
                }	
            }	
        },	
    }
};

// Scopes
const authScopes = {
  scopes: [config.SCOPE],
};

// MSAL Instance
export const msalInstance = new PublicClientApplication(msalConfig);

// Simple auth functions
export const isAuthenticated = (): boolean => {
  return msalInstance.getAllAccounts().length > 0;
};

export const getUserInfo = (): AccountInfo | null => {
  const accounts = msalInstance.getAllAccounts();
  const account = accounts[0] || null;
  return account;
};

export const login = async (): Promise<void> => {
  await msalInstance.loginRedirect(authScopes);
};

export const logout = async (): Promise<void> => {
  const account = getUserInfo();
  if (account) {
    await msalInstance.logoutPopup({ account });
  }
};

export const getAccessToken = async (): Promise<string | null> => {
  const account = getUserInfo();
  if (!account) return null;

  try {
    const response = await msalInstance.acquireTokenSilent({
      ...authScopes,
      account,
    });
    
    return response.accessToken;
  } catch (error: unknown) {
    const err = error as { errorCode?: string; code?: string; message?: string };
    const isTimeoutError = err?.errorCode === 'monitor_window_timeout' || 
                          err?.message?.includes('monitor_window_timeout');
    
    if (isTimeoutError) {
      console.warn('monitor_window_timeout detected - clearing MSAL cache and redirecting to login');
      localStorage.clear();
      // Redirect to login to get fresh tokens
      await msalInstance.acquireTokenRedirect({
        ...authScopes,
        account,
      });
      return null;
    }
    
    // For other errors, try redirect as fallback
    try {
      await msalInstance.acquireTokenRedirect({
        ...authScopes,
        account,
      });
    } catch (redirectError) {
      console.error('Token redirect failed:', redirectError);
    }
    return null;
  }
};
